import {DatabaseCode, toDatabaseCode} from "./database-code";

export type NotificationThreadAssignmentStrategy = DatabaseCode;

const none: NotificationThreadAssignmentStrategy = {
  code: "NONE",
  displayValue: {
    id: "common.entity.notificationtemplatethreadconfig.assignmentstrategy.none",
    defaultMessage: "None",
  },
};

const defaultAssignee: NotificationThreadAssignmentStrategy = {
  code: "DEFAULT_ASSIGNEE",
  displayValue: {
    id: "common.entity.notificationtemplatethreadconfig.assignmentstrategy.defaultassignee",
    defaultMessage: "Default Assignee",
  },
};

const contextOwner: NotificationThreadAssignmentStrategy = {
  code: "CONTEXT_OWNER",
  displayValue: {
    id: "common.entity.notificationtemplatethreadconfig.assignmentstrategy.contextowner",
    defaultMessage: "Context Owner",
  },
};

const sender: NotificationThreadAssignmentStrategy = {
  code: "SENDER",
  displayValue: {
    id: "common.entity.notificationtemplatethreadconfig.assignmentstrategy.sender",
    defaultMessage: "Sender",
  },
};

const receiverQueue: NotificationThreadAssignmentStrategy = {
  code: "RECEIVER_QUEUE",
  displayValue: {
    id: "common.entity.notificationtemplatethreadconfig.assignmentstrategy.receiverqueue",
    defaultMessage: "Receiver Queue",
  },
};

export const notificationThreadAssignmentStrategy = {
  none,
  defaultAssignee,
  contextOwner,
  sender,
  receiverQueue,
};

export const notificationThreadAssignmentStrategies = Object.values(notificationThreadAssignmentStrategy);

export const toNotificationThreadAssignmentStrategy = (code: string): NotificationThreadAssignmentStrategy =>
  toDatabaseCode(code, notificationThreadAssignmentStrategies);

export const toNotificationThreadAssignmentStrategySafely = (
  code: string | undefined,
): NotificationThreadAssignmentStrategy | undefined =>
  code ? toDatabaseCode(code, notificationThreadAssignmentStrategies) : undefined;
